export enum AppRoutesEnum {
  Login = 'login',
  Otp = 'otp',
  Investigations = 'investigations',
  InvestigationsOverall = 'overall',
  InvestigationsEntity = 'relations',
  PolicySettings = 'policy-settings',
  PolicySettingsPolicies = 'policies',
  PolicySettingsLists = 'lists',
  PolicySettingsAlerts = 'alerts',
  Organization = 'organization',
  UsersManagement = 'users-management',
  UsersManagementUsers = 'users',
  UsersManagementRoles = 'roles',
  UsersManagementRolesWrite = 'roles-write',
  AccessDenied = 'access-denied',
  NotFound = 'not-found',
  Fingerprints = 'fingerprints',
  FingerprintsWrite = 'fingerprints-write',
  ApiKeys = 'api-keys',
  ApiKeysWrite = 'api-keys-write',
  Error = 'error',
}
